import type { ProcessStep } from '../types/content'

export const processSteps: ProcessStep[] = [
  {
    index: '01',
    name: 'Discovery',
    label: 'Step 1',
    description:
      'One 90-minute session with whoever owns the decisions, plus a read of your analytics, enquiries and competitors. Usually two to three days.',
    deliverables: ['Positioning brief', 'Audience map', 'Content inventory'],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/183824bc-703e-4a55-84b5-8e45023cd7d7.jpg',
    alt: 'A printed brief resting on a pale oak desk beside a folded sheet of paper',
  },
  {
    index: '02',
    name: 'Strategy',
    label: 'Step 2',
    description:
      'We decide what each page has to do before anything gets drawn, and we write the words to do it. Three to five days, depending on page count.',
    deliverables: ['Sitemap', 'Page-by-page messaging', 'Low-fidelity wireframes'],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/9743ef6f-e144-4e6c-a0fd-5ca6177d3563.jpg',
    alt: 'Hand-drawn pencil wireframes of page layouts on grid paper',
  },
  {
    index: '03',
    name: 'Design',
    label: 'Step 3',
    description:
      'Every page designed at desktop and mobile, presented live on a call — never as a PDF you have to decode. The longest phase, and the one that scales with the plan.',
    deliverables: ['Full page designs', 'Component library', 'Feedback rounds as agreed'],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/18c614fb-d6f5-4de1-8cd1-29a9920b511e.jpg',
    alt: 'A monitor on a desk showing a page layout in progress as soft grey blocks and rules',
  },
  {
    index: '04',
    name: 'Build',
    label: 'Step 4',
    description:
      'Built on the platform that fits your team, with a CMS you can update on a Tuesday afternoon. Scales with the number of pages and CMS templates.',
    deliverables: ['Responsive build', 'CMS setup', 'Performance & SEO pass'],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/4d6d7e8c-b52a-4e87-ab59-44d0e98c9938.jpg',
    alt: 'A laptop and a second display side by side, one holding the build and one the browser',
  },
  {
    index: '05',
    name: 'Launch & Support',
    label: 'Step 5',
    description:
      'We ship it, watch it, and stay on call for a month while the first real traffic arrives. Launch takes a day or two; support runs a full thirty.',
    deliverables: ['Launch checklist', 'Analytics & tracking', 'Training video', '30-day support'],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/544bbd2e-c8bf-4df7-9379-840afd51400d.jpg',
    alt: 'A phone resting on a linen notebook, showing a finished site laid out on its screen',
  },
]
